import React, {useState, useEffect} from "react";
import { Modal } from "@redq/reuse-modal";
import {
	TextField,
	MenuItem,
	Button,
	Card,
	Typography,
	Grid,
	FormControl,
	InputLabel,
	Select as MuiSelect,
	Box,
	CircularProgress,
	Paper,
	IconButton,
	Divider,
	Chip,
	Collapse,
	FormControlLabel,
	Checkbox
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import GetAppIcon from '@material-ui/icons/GetApp';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import FilterListIcon from '@material-ui/icons/FilterList';
import {makeStyles} from '@material-ui/core/styles';
import Select from 'react-select';
import { AuthContext } from "../../contexts/auth/auth.context";
import {getSuppliers, getWarehouses} from '../../store/actions/dashboardAction';
import { connect } from "react-redux";
import API from "../../network/dashboardAPI";
import moment from 'moment';
import "react-datetime/css/react-datetime.css";
import Datetime from 'react-datetime';
// React-Select Custom Styles
const customSelectStyles = {
	control: (provided, state) => ({
		...provided,
		borderColor: state.isFocused ? '#9cc54b' : 'rgba(0, 0, 0, 0.23)',
		boxShadow: state.isFocused ? '0 0 0 2px rgba(156, 197, 75, 0.2)' : 'none',
		'&:hover': {
			borderColor: state.isFocused ? '#9cc54b' : 'rgba(0, 0, 0, 0.87)',
		},
		minHeight: '56px',
		borderRadius: '8px',
		backgroundColor: 'white',
	}),
	menu: (provided) => ({
		...provided,
		borderRadius: '8px',
		boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
		border: '1px solid #e2e8f0',
		marginTop: '4px',
		zIndex: 9999,
	}),
	menuList: (provided) => ({
		...provided,
		padding: '4px',
		maxHeight: '300px',
	}),
	option: (provided, state) => ({
		...provided,
		backgroundColor: state.isSelected ? '#9cc54b' : state.isFocused ? '#f7fafc' : 'white',
		color: state.isSelected ? 'white' : '#2d3748',
		padding: '10px 12px',
		borderRadius: '6px',
		margin: '2px 0',
		cursor: 'pointer',
		'&:active': {
			backgroundColor: '#8ab43d',
		},
	}),
	multiValue: (provided) => ({
		...provided,
		backgroundColor: '#e8f5e9',
		borderRadius: '16px',
		padding: '2px',
	}),
	multiValueLabel: (provided) => ({
		...provided,
		color: '#2e7d32',
		fontWeight: 500,
		padding: '2px 6px',
	}),
	multiValueRemove: (provided) => ({
		...provided,
		color: '#2e7d32',
		borderRadius: '0 16px 16px 0',
		':hover': {
			backgroundColor: '#9cc54b',
			color: 'white',
		},
	}),
	placeholder: (provided) => ({
		...provided,
		color: '#a0aec0',
	}),
};
const useStyles = makeStyles((theme) => ({
	pageWrapper: {
		backgroundColor: '#f7fafc',
		minHeight: '100vh',
		padding: theme.spacing(4, 3),
		overflow: 'visible',
		[theme.breakpoints.down('sm')]: {
			paddingTop: theme.spacing(12),
			padding: theme.spacing(12, 2, 4, 2),
		},
	},
	container: {
		maxWidth: 1200,
		margin: '0 auto',
		overflow: 'visible',
	},
	pageHeader: {
		marginBottom: theme.spacing(4),
	},
	pageTitle: {
		color: '#1a202c',
		fontWeight: 700,
		fontSize: '2rem',
		letterSpacing: '-0.5px',
		marginBottom: theme.spacing(1),
	},
	pageSubtitle: {
		color: '#718096',
		fontSize: '1rem',
	},
	card: {
		marginBottom: theme.spacing(3),
		borderRadius: 16,
		boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.1)',
		border: '1px solid #e2e8f0',
		transition: 'box-shadow 0.3s ease, transform 0.2s ease',
		overflow: 'visible !important',
		'&:hover': {
			boxShadow: '0 4px 6px rgba(0, 0, 0, 0.07), 0 2px 4px rgba(0, 0, 0, 0.06)',
		},
		'& > *': {
			overflow: 'visible !important',
		},
	},
	cardHeader: {
		padding: theme.spacing(3),
		backgroundColor: '#ffffff',
		borderBottom: '1px solid #e2e8f0',
		overflow: 'visible',
	},
	cardTitle: {
		color: '#1a202c',
		fontWeight: 600,
		fontSize: '1.25rem',
		display: 'flex',
		alignItems: 'center',
		marginBottom: theme.spacing(0.5),
	},
	cardTitleIcon: {
		marginRight: theme.spacing(1.5),
		color: '#9cc54b',
		fontSize: '1.5rem',
	},
	cardDescription: {
		color: '#718096',
		fontSize: '0.875rem',
		marginTop: theme.spacing(0.5),
		lineHeight: 1.5,
	},
	cardContent: {
		padding: theme.spacing(3),
		overflow: 'visible !important',
		'& > *': {
			overflow: 'visible !important',
		},
	},
	sectionDivider: {
		margin: theme.spacing(3, 0),
		backgroundColor: '#e2e8f0',
	},
	filterSection: {
		backgroundColor: '#f7fafc',
		padding: theme.spacing(2.5),
		borderRadius: 12,
		border: '1px solid #e2e8f0',
		marginBottom: theme.spacing(2),
		overflow: 'visible',
	},
	filterHeader: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		cursor: 'pointer',
	},
	filterContent: {
		marginTop: theme.spacing(2.5),
	},
	filterField: {
		marginBottom: theme.spacing(1),
		'& .MuiFormControl-root': {
			marginBottom: 0,
		},
	},
	filterTitle: {
		display: 'flex',
		alignItems: 'center',
		color: '#2d3748',
		fontWeight: 600,
		fontSize: '0.95rem',
	},
	filterIcon: {
		marginRight: theme.spacing(1),
		color: '#9cc54b',
		fontSize: '1.2rem',
	},
	button: {
		backgroundColor: '#9cc54b',
		color: 'white',
		padding: theme.spacing(1.5, 4),
		fontWeight: 600,
		borderRadius: 10,
		textTransform: 'none',
		fontSize: '0.95rem',
		minHeight: 48,
		boxShadow: '0 2px 4px rgba(156, 197, 75, 0.25)',
		transition: 'all 0.2s ease',
		'&:hover': {
			backgroundColor: '#8ab43d',
			boxShadow: '0 4px 12px rgba(156, 197, 75, 0.35)',
			transform: 'translateY(-1px)',
		},
		'&:disabled': {
			backgroundColor: '#cbd5e0',
			color: '#a0aec0',
		},
	},
	formControl: {
		width: '100%',
	},
	select: {
		'& .MuiOutlinedInput-root': {
			borderRadius: 8,
			'&.Mui-focused fieldset': {
				borderColor: '#9cc54b',
				borderWidth: 2,
			},
		},
		'& .MuiInputLabel-root.Mui-focused': {
			color: '#9cc54b',
		},
	},
	menuItem: {
		padding: theme.spacing(1.5, 2),
		'&:hover': {
			backgroundColor: '#f7fafc',
		},
	},
	menuItemContent: {
		display: 'flex',
		flexDirection: 'column',
		gap: theme.spacing(0.5),
	},
	textField: {
		'& .MuiOutlinedInput-root': {
			borderRadius: 8,
			'&.Mui-focused fieldset': {
				borderColor: '#9cc54b',
				borderWidth: 2,
			},
		},
		'& .MuiInputLabel-root.Mui-focused': {
			color: '#9cc54b',
		},
	},
	selectLabel: {
		fontWeight: 600,
		color: '#2d3748',
		marginBottom: theme.spacing(1.25),
		fontSize: '0.875rem',
		display: 'block',
		lineHeight: 1.5,
	},
	alert: {
		borderRadius: 12,
		marginBottom: theme.spacing(3),
		padding: theme.spacing(2, 3),
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		border: '1px solid',
		animation: '$slideIn 0.3s ease-out',
	},
	alertSuccess: {
		backgroundColor: '#f0fdf4',
		borderColor: '#86efac',
		color: '#166534',
	},
	alertError: {
		backgroundColor: '#fef2f2',
		borderColor: '#fca5a5',
		color: '#991b1b',
	},
	'@keyframes slideIn': {
		from: {
			opacity: 0,
			transform: 'translateY(-10px)',
		},
		to: {
			opacity: 1,
			transform: 'translateY(0)',
		},
	},
	datePickerWrapper: {
		position: 'relative',
		'& .form-control': {
			width: '100%',
			padding: '16.5px 14px',
			fontSize: '1rem',
			fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
			border: '1px solid rgba(0, 0, 0, 0.23)',
			borderRadius: 8,
			transition: 'border-color 0.2s ease',
			backgroundColor: 'white',
			'&:focus': {
				outline: 'none',
				borderColor: '#9cc54b',
				borderWidth: 2,
			},
			'&:hover': {
				borderColor: 'rgba(0, 0, 0, 0.87)',
			},
		},
		'& .rdtPicker': {
			position: 'absolute',
			zIndex: 9999,
			marginTop: theme.spacing(1),
			borderRadius: 12,
			boxShadow: '0 10px 25px rgba(0, 0, 0, 0.15)',
			border: '1px solid #e2e8f0',
			backgroundColor: 'white',
		},
		'& .rdtDay.rdtActive, & .rdtDay.rdtActive:hover': {
			backgroundColor: '#9cc54b !important',
		},
		'& .rdtDay:hover': {
			backgroundColor: '#f0f4f8',
		},
	},
	extractLevelInfo: {
		marginTop: theme.spacing(1.5),
		padding: theme.spacing(2),
		backgroundColor: '#edf2f7',
		borderRadius: 8,
		fontSize: '0.875rem',
		color: '#2d3748',
		border: '1px solid #cbd5e0',
		display: 'flex',
		alignItems: 'flex-start',
	},
	infoIcon: {
		marginRight: theme.spacing(1),
		color: '#9cc54b',
		fontSize: '1.2rem',
		marginTop: 2,
	},
	levelChip: {
		marginLeft: theme.spacing(1),
		height: 24,
		fontSize: '0.75rem',
		fontWeight: 600,
	},
	chipSales: {
		backgroundColor: '#dbeafe',
		color: '#1e40af',
	},
	chipSupplier: {
		backgroundColor: '#fef3c7',
		color: '#92400e',
	},
	chipStock: {
		backgroundColor: '#e0e7ff',
		color: '#3730a3',
	},
}));

const BulkExtract = (props) => {
	const classes = useStyles();

	let admin = localStorage.getItem("admin");
	if (!admin) {
		window.location.href = "/";
	}

	const [fromDate, setFromDate] = useState();
	const [toDate, setToDate] = useState();
	const [show, setShow] = useState(false);
	const [message, setMessage] = useState();
	const [isValid, setIsValid] = useState(true);
	const [loading, setLoading] = useState(false);
	const [loadingType, setLoadingType] = useState('');

	// Product Extract Filters
	const [extractLevel, setExtractLevel] = useState('sales');
	const [selectedSuppliers, setSelectedSuppliers] = useState([]);
	const [selectedWarehouses, setSelectedWarehouses] = useState([]);
	const [stockType, setStockType] = useState('all');
	const [minQuantity, setMinQuantity] = useState('');
	const [maxQuantity, setMaxQuantity] = useState('');
	const [showFilters, setShowFilters] = useState(true);
	const [includeDeleted, setIncludeDeleted] = useState(false);

	useEffect(() => {
		if (props.getSuppliers) {
			props.getSuppliers({});
		}
		if (props.getWarehouses) {
			props.getWarehouses({});
		}
	}, []);

	const handleFromDate = event => setFromDate(moment(event).format('YYYY-MM-DD'));
	const handleToDate = event => setToDate(moment(event).format('YYYY-MM-DD'));

	const handleProductExtract = () => {
		setLoading(true);
		setLoadingType('product');

		const payload = {
			extractLevel: extractLevel,
			supplierIds: selectedSuppliers?.map(s => s.value) || [],
			warehouseIds: selectedWarehouses?.map(w => w.value) || [],
			stockType: stockType || 'all',
			minQuantity: minQuantity || '',
			maxQuantity: maxQuantity || '',
			includeDeleted: includeDeleted,
		};

		console.log('Sending Product Extract payload:', payload);

		API.productExtract(payload)
			.then(res => res.json())
			.then(response => {
				setLoading(false);
				setIsValid(true);
				setMessage(response.data);
				setShow(true);
				setTimeout(() => setShow(false), 5000);
			}).catch(err => {
			setLoading(false);
			setIsValid(false);
			setMessage("Failed to generate product extract. Please try again.");
			setShow(true);
			setTimeout(() => setShow(false), 5000);
		});
	};

	const handlePromotionExtract = () => {
		setLoading(true);
		setLoadingType('promotion');
		API.promotionExtract()
			.then(res => res.json())
			.then(response => {
				setLoading(false);
				setIsValid(true);
				setMessage(response.data);
				setShow(true);
				setTimeout(() => setShow(false), 5000);
			}).catch(err => {
			setLoading(false);
			setIsValid(false);
			setMessage("Failed to generate promotion extract. Please try again.");
			setShow(true);
			setTimeout(() => setShow(false), 5000);
		});
	};

	const handleOrderReport = e => {
		e.preventDefault();
		if (!(fromDate && toDate)) {
			setIsValid(false);
			setMessage("Please select both From and To dates!");
			setShow(true);
			setTimeout(() => setShow(false), 5000);
		} else {
			setLoading(true);
			setLoadingType('order');
			API.orderReport({
				from: fromDate,
				to: toDate
			}).then(res => res.json()).then(response => {
				setLoading(false);
				setIsValid(true);
				setMessage(response.data);
				setShow(true);
				setTimeout(() => setShow(false), 5000);
			}).catch(err => {
				setLoading(false);
				setIsValid(false);
				setMessage("Failed to generate order report. Please try again.");
				setShow(true);
				setTimeout(() => setShow(false), 5000);
			});
		}
	};

	const supplierOptions = props.suppliers?.map(supplier => ({
		value: supplier.store_user_id,
		label: `${supplier.store_users[0]?.first_name} ${supplier.store_users[0]?.last_name}`
	})) || [];

	const warehouseOptions = props.warehouses?.map(warehouse => ({
		value: warehouse.id,
		label: warehouse.name
	})) || [];

	const getExtractLevelDescription = () => {
		switch (extractLevel) {
			case 'sales':
				return {
					text: 'Exports basic product information with sales data. Suitable for bulk upload operations.',
					columns: 'Blue columns only',
					rows: 'One row per product'
				};
			case 'supplier':
				return {
					text: 'Exports product information with supplier details and mappings.',
					columns: 'Blue + Green columns',
					rows: 'Multiple rows per product (one per supplier)'
				};
			case 'stock':
				return {
					text: 'Exports complete product information including warehouse stock levels.',
					columns: 'Blue + Green + Grey columns',
					rows: 'Multiple rows per product (one per warehouse location)'
				};
			default:
				return {text: '', columns: '', rows: ''};
		}
	};

	const getChipClass = () => {
		switch (extractLevel) {
			case 'sales':
				return classes.chipSales;
			case 'supplier':
				return classes.chipSupplier;
			case 'stock':
				return classes.chipStock;
			default:
				return '';
		}
	};

	return (
		<Modal>
			<div className={classes.pageWrapper}>
				<div className={classes.container}>
					{/* Page Header */}
					<Box className={classes.pageHeader}>
						<Typography variant="h4" className={classes.pageTitle}>
							Data Extract Center
						</Typography>
						<Typography className={classes.pageSubtitle}>
							Export and analyze your business data with customizable filters
						</Typography>
					</Box>

					{/* Alert Messages */}
					{show && (
						<Paper
							className={`${classes.alert} ${isValid ? classes.alertSuccess : classes.alertError}`}
							elevation={0}
						>
							<Typography variant="body1" style={{flex: 1, fontWeight: 500}}>
								{message}
							</Typography>
							<IconButton
								size="small"
								onClick={() => setShow(false)}
								style={{marginLeft: 16}}
							>
								<CloseIcon fontSize="small"/>
							</IconButton>
						</Paper>
					)}

					{/* Product Extract Card */}
					<Card className={classes.card} style={{overflow: 'visible'}}>
						<Box className={classes.cardHeader} style={{overflow: 'visible'}}>
							<Typography className={classes.cardTitle}>
								<GetAppIcon className={classes.cardTitleIcon}/>
								Product Extract
								<Chip
									label={extractLevel.charAt(0).toUpperCase() + extractLevel.slice(1)}
									className={`${classes.levelChip} ${getChipClass()}`}
									size="small"
								/>
							</Typography>
							<Typography className={classes.cardDescription}>
								Export your product catalog with flexible data levels and advanced filtering options
							</Typography>
						</Box>

						<Box className={classes.cardContent} style={{overflow: 'visible'}}>
							<Grid container spacing={3} style={{overflow: 'visible'}}>
								{/* Extract Level Selection */}
								<Grid item xs={12} style={{overflow: 'visible'}}>
									<FormControl variant="outlined" className={classes.formControl}>
										<InputLabel>Data Level *</InputLabel>
										<MuiSelect
											value={extractLevel}
											onChange={(e) => setExtractLevel(e.target.value)}
											label="Data Level *"
											className={classes.select}
											MenuProps={{
												PaperProps: {
													style: {
														maxHeight: 400,
													},
												},
												anchorOrigin: {
													vertical: 'bottom',
													horizontal: 'left',
												},
												transformOrigin: {
													vertical: 'top',
													horizontal: 'left',
												},
												getContentAnchorEl: null,
											}}
										>
											<MenuItem value="sales" className={classes.menuItem}>
												<Box className={classes.menuItemContent}>
													<Typography variant="body1" style={{fontWeight: 600, fontSize: '0.95rem'}}>
														Sales Product Level
													</Typography>
													<Typography variant="caption" color="textSecondary" style={{fontSize: '0.75rem'}}>
														Basic product info - One row per product
													</Typography>
												</Box>
											</MenuItem>
											<MenuItem value="supplier" className={classes.menuItem}>
												<Box className={classes.menuItemContent}>
													<Typography variant="body1" style={{fontWeight: 600, fontSize: '0.95rem'}}>
														Supplier Product Level
													</Typography>
													<Typography variant="caption" color="textSecondary" style={{fontSize: '0.75rem'}}>
														Includes supplier mappings - Multiple rows per product
													</Typography>
												</Box>
											</MenuItem>
											<MenuItem value="stock" className={classes.menuItem}>
												<Box className={classes.menuItemContent}>
													<Typography variant="body1" style={{fontWeight: 600, fontSize: '0.95rem'}}>
														Stock Level
													</Typography>
													<Typography variant="caption" color="textSecondary" style={{fontSize: '0.75rem'}}>
														Full warehouse data - Multiple rows per location
													</Typography>
												</Box>
											</MenuItem>
										</MuiSelect>
									</FormControl>

									<Box className={classes.extractLevelInfo}>
										<InfoOutlinedIcon className={classes.infoIcon}/>
										<Box>
											<Typography variant="body2" style={{fontWeight: 600, marginBottom: 4}}>
												{getExtractLevelDescription().text}
											</Typography>
											<Typography variant="caption" color="textSecondary">
												<strong>Columns:</strong> {getExtractLevelDescription().columns} • <strong>Rows:</strong> {getExtractLevelDescription().rows}
											</Typography>
										</Box>
									</Box>
								</Grid>

								<Grid item xs={12} style={{overflow: 'visible'}}>
									<Divider className={classes.sectionDivider}/>
								</Grid>

								{/* Advanced Filters Section */}
								<Grid item xs={12} style={{overflow: 'visible'}}>
									<Box className={classes.filterSection}>
										<Box
											className={classes.filterHeader}
											onClick={() => setShowFilters(!showFilters)}
										>
											<Typography className={classes.filterTitle}>
												<FilterListIcon className={classes.filterIcon}/>
												Advanced Filters (Optional)
											</Typography>
											<IconButton size="small">
												{showFilters ? <ExpandLessIcon/> : <ExpandMoreIcon/>}
											</IconButton>
										</Box>

										<Collapse in={showFilters}>
											<Box className={classes.filterContent}>
												<Grid container spacing={3} style={{overflow: 'visible'}}>
													<Grid item xs={12} md={6} style={{overflow: 'visible'}}>
														<Box className={classes.filterField}>
															<Typography className={classes.selectLabel}>
																Suppliers
															</Typography>
															<Select
																isMulti
																options={supplierOptions}
																value={selectedSuppliers}
																onChange={setSelectedSuppliers}
																styles={customSelectStyles}
																placeholder="Select suppliers to filter..."
																isClearable
																isSearchable
															/>
														</Box>
													</Grid>

													<Grid item xs={12} md={6} style={{overflow: 'visible'}}>
														<Box className={classes.filterField}>
															<Typography className={classes.selectLabel}>
																Warehouses
															</Typography>
															<Select
																isMulti
																options={warehouseOptions}
																value={selectedWarehouses}
																onChange={setSelectedWarehouses}
																styles={customSelectStyles}
																placeholder="Select warehouses to filter..."
																isClearable
																isSearchable
															/>
														</Box>
													</Grid>

													<Grid item xs={12} md={stockType === 'low_stock' ? 4 : 12} style={{overflow: 'visible'}}>
														<Box className={classes.filterField}>
															<FormControl variant="outlined" className={classes.formControl}>
																<InputLabel>Stock Filter</InputLabel>
																<MuiSelect
																	value={stockType}
																	onChange={(e) => setStockType(e.target.value)}
																	label="Stock Filter"
																	className={classes.select}
																	MenuProps={{
																		PaperProps: {
																			style: {
																				maxHeight: 300,
																			},
																		},
																		anchorOrigin: {
																			vertical: 'bottom',
																			horizontal: 'left',
																		},
																		transformOrigin: {
																			vertical: 'top',
																			horizontal: 'left',
																		},
																		getContentAnchorEl: null,
																	}}
																>
																	<MenuItem value="all">All Products</MenuItem>
																	<MenuItem value="in_stock">In Stock (Qty &gt; 0)</MenuItem>
																	<MenuItem value="low_stock">Low Stock Range</MenuItem>
																	<MenuItem value="out_of_stock">Out of Stock (Qty = 0)</MenuItem>
																</MuiSelect>
															</FormControl>
														</Box>
													</Grid>

													{stockType === 'low_stock' && (
														<>
															<Grid item xs={12} md={4}>
																<Box className={classes.filterField}>
																	<TextField
																		type="number"
																		label="Min Quantity"
																		variant="outlined"
																		fullWidth
																		placeholder="0"
																		value={minQuantity}
																		onChange={(e) => setMinQuantity(e.target.value)}
																		className={classes.textField}
																		inputProps={{min: 0}}
																	/>
																</Box>
															</Grid>
															<Grid item xs={12} md={4}>
																<Box className={classes.filterField}>
																	<TextField
																		type="number"
																		label="Max Quantity"
																		variant="outlined"
																		fullWidth
																		placeholder="10"
																		value={maxQuantity}
																		onChange={(e) => setMaxQuantity(e.target.value)}
																		className={classes.textField}
																		inputProps={{min: 0}}
																	/>
																</Box>
															</Grid>
														</>
													)}

													<Grid item xs={12}>
														<Box className={classes.filterField}>
															<FormControlLabel
																control={
																	<Checkbox
																		checked={includeDeleted}
																		onChange={(e) => setIncludeDeleted(e.target.checked)}
																		style={{color: '#9cc54b'}}
																	/>
																}
																label="Include Deleted Products"
															/>
														</Box>
													</Grid>
												</Grid>
											</Box>
										</Collapse>
									</Box>
								</Grid>

								<Grid item xs={12}>
									<Box display="flex" justifyContent="flex-end" mt={1}>
										<Button
											variant="contained"
											className={classes.button}
											onClick={handleProductExtract}
											disabled={loading}
											startIcon={loading && loadingType === 'product' ? <CircularProgress size={20} color="inherit"/> :
												<GetAppIcon/>}
										>
											{loading && loadingType === 'product' ? 'Generating Extract...' : 'Generate Extract'}
										</Button>
									</Box>
								</Grid>
							</Grid>
						</Box>
					</Card>

					{/* Promotion Extract Card */}
					<Card className={classes.card} style={{overflow: 'visible'}}>
						<Box className={classes.cardHeader} style={{overflow: 'visible'}}>
							<Typography className={classes.cardTitle}>
								<GetAppIcon className={classes.cardTitleIcon}/>
								Promotion Extract
							</Typography>
							<Typography className={classes.cardDescription}>
								Export all products currently on promotion with pricing details
							</Typography>
						</Box>
						<Box className={classes.cardContent} style={{overflow: 'visible'}}>
							<Box display="flex" justifyContent="flex-end" style={{overflow: 'visible'}}>
								<Button
									variant="contained"
									className={classes.button}
									onClick={handlePromotionExtract}
									disabled={loading}
									startIcon={loading && loadingType === 'promotion' ? <CircularProgress size={20} color="inherit"/> :
										<GetAppIcon/>}
								>
									{loading && loadingType === 'promotion' ? 'Generating Extract...' : 'Generate Extract'}
								</Button>
							</Box>
						</Box>
					</Card>

					{/* Order Report Card */}
					<Card className={classes.card} style={{overflow: 'visible'}}>
						<Box className={classes.cardHeader} style={{overflow: 'visible'}}>
							<Typography className={classes.cardTitle}>
								<GetAppIcon className={classes.cardTitleIcon}/>
								Order Report
							</Typography>
							<Typography className={classes.cardDescription}>
								Generate comprehensive order reports for a specific date range
							</Typography>
						</Box>
						<Box className={classes.cardContent} style={{overflow: 'visible'}}>
							<Grid container spacing={3} style={{overflow: 'visible'}}>
								<Grid item xs={12} md={5} style={{overflow: 'visible'}}>
									<FormControl fullWidth>
										<Typography className={classes.selectLabel}>
											Start Date
										</Typography>
										<div className={classes.datePickerWrapper}>
											<Datetime
												value={fromDate}
												dateFormat="YYYY-MM-DD"
												timeFormat={false}
												onChange={handleFromDate}
												inputProps={{placeholder: 'Select start date'}}
											/>
										</div>
									</FormControl>
								</Grid>
								<Grid item xs={12} md={5} style={{overflow: 'visible'}}>
									<FormControl fullWidth>
										<Typography className={classes.selectLabel}>
											End Date
										</Typography>
										<div className={classes.datePickerWrapper}>
											<Datetime
												value={toDate}
												dateFormat="YYYY-MM-DD"
												timeFormat={false}
												onChange={handleToDate}
												inputProps={{placeholder: 'Select end date'}}
											/>
										</div>
									</FormControl>
								</Grid>
								<Grid item xs={12} md={2} style={{display: 'flex', alignItems: 'flex-end'}}>
									<Button
										variant="contained"
										className={classes.button}
										onClick={handleOrderReport}
										disabled={loading}
										fullWidth
										startIcon={loading && loadingType === 'order' ? <CircularProgress size={20} color="inherit"/> :
											<GetAppIcon/>}
									>
										{loading && loadingType === 'order' ? 'Generating...' : 'Generate'}
									</Button>
								</Grid>
							</Grid>
						</Box>
					</Card>
				</div>
			</div>
		</Modal>
	);
}

const mapStateToProps = state => {
	return {
		suppliers: state.dashboardReducer.suppliers,
		warehouses: state.dashboardReducer.warehouses,
		success: state.dashboardReducer.success,
		loading: state.dashboardReducer.loading,
		error_message: state.dashboardReducer.error_message
	}
}

const mapDispatchToProps = dispatch => {
	return {
		getSuppliers: data => getSuppliers(data, dispatch),
		getWarehouses: data => getWarehouses(data, dispatch)
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(BulkExtract);